import { MultiTierTax } from './../../classes/multiTierTax/multiTierTax';
import { rates } from './config';
import { DividendBelastingConfig } from './interface';

export class DividendBelasting {
    
    tax: number;
    
    constructor(data: DividendBelastingConfig) {
        this.tax = new MultiTierTax(rates[data.year], data.profit).tax;
    }
    
}
